import React, { forwardRef, useContext } from 'react';

import { RicosContext } from './../../../../ricos-context';

import { ContextMenuIcon } from '../../../icons';
import { ToolbarButton } from '../ToolbarButton';
import { MoreButtonDataHook } from './data-hooks';

type MoreButtonProps = {
  onClick: () => void;
  shouldShowMore: boolean;
};

const MoreButton = forwardRef<HTMLButtonElement, MoreButtonProps>(
  ({ onClick, shouldShowMore }, ref) => {
    const { t } = useContext(RicosContext);
    return (
      <ToolbarButton
        ref={ref}
        tooltip={t('MoreButton_Tooltip')}
        active={shouldShowMore}
        onClick={onClick}
        icon={() => <ContextMenuIcon style={{ pointerEvents: 'none' }} />}
        dataHook={MoreButtonDataHook}
      />
    );
  }
);

export default MoreButton;
